import type { Channel, Chapter, Me, Video } from './types';

export const MOCK_CHANNELS: Channel[] = [
  {
    channelId: 'allhands',
    name: '全社会議',
    tint: '#4A5C8C',
    count: 14,
    updated: '3日前',
    description: 'キックオフ・朝会・月次共有のアーカイブ。参加できなかった回はここから追いつけます。',
  },
  {
    channelId: 'onboarding',
    name: 'オンボーディング',
    tint: '#9A6E1C',
    count: 9,
    updated: '2週間前',
    description: '入社時に見ておいてほしい動画と、全社員必修の研修をまとめています。',
  },
  {
    channelId: 'lt',
    name: '技術勉強会・LT',
    tint: '#3A6EA5',
    count: 21,
    updated: '5日前',
    description: '毎月の社内LTと勉強会の録画。気になるテーマだけ拾って見てください。',
  },
  {
    channelId: 'sales',
    name: '営業ナレッジ',
    tint: '#7E5AA6',
    count: 17,
    updated: '4日前',
    description: '提案の型、製品デモ、受注事例のふりかえり。商談前の予習に。',
  },
  {
    channelId: 'event',
    name: '社内イベント',
    tint: '#A45E22',
    count: 11,
    updated: '1か月前',
    description: '社内フェス、表彰式、部活動。あとから見返すとけっこう楽しいやつです。',
  },
];

const base = (v: Partial<Video> & Pick<Video, 'videoId' | 'title' | 'channelId' | 'presenter'>): Video => ({
  videoId: v.videoId,
  title: v.title,
  description: v.description ?? '',
  channelId: v.channelId,
  channelName: MOCK_CHANNELS.find((c) => c.channelId === v.channelId)?.name ?? '',
  presenter: v.presenter,
  presenterInitial: v.presenter.slice(-2, -1),
  tint: v.tint ?? '#1E3A6B',
  durationSec: v.durationSec ?? 0,
  duration: v.duration ?? '00:00',
  views: v.views ?? 0,
  publishedAt: v.publishedAt ?? new Date().toISOString(),
  status: 'published',
  tags: v.tags ?? [],
  visibility: 'company',
  videoKey: `videos/${v.videoId}/original`,
  progress: v.progress ?? '0%',
});

export const MOCK_VIDEOS: Video[] = [
  base({
    videoId: 'kickoff',
    title: '2026年下期キックオフ全社会議',
    channelId: 'allhands',
    presenter: '代表 田村',
    duration: '42:10',
    durationSec: 2530,
    views: 96,
    tint: '#4A5C8C',
    progress: '29%',
    description:
      '下期の全社方針、各本部の重点テーマ、そしてQ&Aまでのフルアーカイブです。参加できなかった方はチャプターから必要なところだけでも見ておいてください。',
    tags: ['全社会議', '方針', '2026下期'],
  }),
  base({
    videoId: 'onboard',
    title: '入社1日目に見る：会社のなりたちと大事にしていること',
    channelId: 'onboarding',
    presenter: '人事 佐野',
    duration: '18:40',
    durationSec: 1120,
    views: 61,
    tint: '#9A6E1C',
    progress: '100%',
    description: '新しく入った方向けの最初の1本。会社の成り立ち、意思決定の考え方、社内の呼び方や文化についてまとめました。',
    tags: ['オンボーディング', '必修'],
  }),
  base({
    videoId: 'lt7',
    title: '社内LT #7「テストを書くのが楽しくなる小さな工夫」',
    channelId: 'lt',
    presenter: '開発 岸本',
    duration: '12:05',
    durationSec: 725,
    views: 38,
    tint: '#3A6EA5',
    progress: '0%',
    description: '毎月やっている社内LTの第7回。テストの書き始めのハードルを下げる工夫を10分でまとめています。',
    tags: ['LT', 'テスト', '開発'],
  }),
  base({
    videoId: 'sales',
    title: '受注につながった提案の共通点（2026上期ふりかえり）',
    channelId: 'sales',
    presenter: '営業 三宅',
    duration: '26:30',
    durationSec: 1590,
    views: 44,
    tint: '#7E5AA6',
    progress: '11%',
    description: '上期に受注できた案件の提案資料を並べて、共通していた考え方を整理しました。提案前に一度どうぞ。',
    tags: ['営業', '提案', 'ナレッジ'],
  }),
  base({
    videoId: 'festa',
    title: '社内フェス2026 ダイジェスト',
    channelId: 'event',
    presenter: '広報 小川',
    duration: '06:22',
    durationSec: 382,
    views: 82,
    tint: '#A45E22',
    progress: '0%',
    description: '今年の社内フェスの様子を6分にまとめました。来年の参加検討にもぜひ。',
    tags: ['イベント', 'ダイジェスト'],
  }),
  base({
    videoId: 'product',
    title: '新機能デモ：レポート自動生成のつかいどころ',
    channelId: 'sales',
    presenter: 'PdM 中西',
    duration: '15:18',
    durationSec: 918,
    views: 57,
    tint: '#22687A',
    progress: '46%',
    description: 'リリースした自動レポート機能の実演と、お客様に説明するときの言い方をまとめています。',
    tags: ['製品', 'デモ', '新機能'],
  }),
  base({
    videoId: 'security',
    title: '年次セキュリティ研修 2026',
    channelId: 'onboarding',
    presenter: '情シス 望月',
    duration: '31:00',
    durationSec: 1860,
    views: 73,
    tint: '#8A6D3B',
    progress: '62%',
    description: '全社員必修のセキュリティ研修。最後に確認クイズがあります。',
    tags: ['必修', 'セキュリティ'],
  }),
  base({
    videoId: 'allhands6',
    title: '6月度 朝会アーカイブ',
    channelId: 'allhands',
    presenter: '代表 田村',
    duration: '22:45',
    durationSec: 1365,
    views: 29,
    tint: '#4F6529',
    progress: '0%',
    description: '6月の朝会アーカイブ。数字の共有と新メンバー紹介です。',
    tags: ['朝会', 'アーカイブ'],
  }),
];

export const MOCK_CHAPTERS: Chapter[] = [
  { sec: 0, time: '00:00', label: 'オープニング・今日の流れ' },
  { sec: 210, time: '03:30', label: '上期のふりかえり（数字）' },
  { sec: 750, time: '12:30', label: '下期の全社方針' },
  { sec: 1320, time: '22:00', label: '各本部の重点テーマ' },
  { sec: 1920, time: '32:00', label: 'Q&A' },
];

export const MOCK_ME: Me = {
  userId: 'demo-user',
  email: 'sato@example.com',
  name: '佐藤 みなみ',
  isAdmin: true,
};
